import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { RegionForm } from '../RegionForm';
import { useRegionStore } from '@/stores/regionStore';
import { useUpdateRegion } from '@/hooks/useRegions';
import { UpdateRegionInput } from '@/features/regions/types';

export function RegionEditModal() {
  const { isEditModalOpen, closeEditModal, selectedRegion } = useRegionStore();
  const { mutate: updateRegion, isPending: isLoading } = useUpdateRegion();

  const handleSubmit = (data: UpdateRegionInput) => {
    if (!selectedRegion) return;
    
    updateRegion(
      { id: selectedRegion.id, data },
      {
        onSuccess: () => {
          closeEditModal();
        }
      }
    );
  };

  if (!selectedRegion) return null;

  return (
    <Dialog open={isEditModalOpen} onOpenChange={(open) => !open && closeEditModal()}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Region</DialogTitle>
        </DialogHeader>
        <RegionForm
          region={selectedRegion}
          onSubmit={handleSubmit}
          isSubmitting={isLoading}
        />
      </DialogContent>
    </Dialog>
  );
}
